import _Vue, { PluginFunction, PluginObject } from 'vue';
import Vue from 'vue';

export default class Session implements PluginObject<{}> {
  private options: any;
  [key: string]: any;

  public static install(vue: typeof _Vue, options?: {}) {
    vue.$session = new Session(options);
  }

  constructor(options?: {}) {
    this.options = options;
  }

  public install(vue: typeof _Vue, options?: {}) {
    vue.$session = this;
  }

  public create(user: any) {
    localStorage.setItem('user', JSON.stringify(user));
  }

  public cookieConsent(consent: boolean) {
    localStorage.setItem('cookieConsent', String(consent));
  }

  public destroy() {
    localStorage.removeItem('user');
  }

  public get() {
    return localStorage.getItem('user');
  }

  public isAuthenticated(): boolean {
    return localStorage.getItem('user') != null;
  }

  public isCookieConsented(): boolean {
    return localStorage.getItem('cookieConsent') === 'true';
  }
}

declare module 'vue/types/vue' {
  interface Vue {
    $session: Session;
  }
  interface VueConstructor {
    $session: Session;
  }
}

declare module 'vue/types/options' {
  interface ComponentOptions<V extends Vue> {
    session?: Session;
  }
}
